import styled from 'styled-components'

export const StyledTrashTable = styled.div`
  position: relative;
  width: 100%;
`
